(function () {
  'use strict';

  var SECTION_SELECTOR = '.oddit-section-featured-reviews';
  var sectionState = new Map();

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function initSection(section) {
    if (!section || sectionState.has(section)) return;

    var track = section.querySelector('[data-oddit-carousel-track]');
    if (!track) return;

    var slides = track.querySelectorAll('.oddit-section-featured-reviews__review');
    if (!slides.length) return;

    var prevButtons = section.querySelectorAll('[data-oddit-carousel-prev]');
    var nextButtons = section.querySelectorAll('[data-oddit-carousel-next]');
    var counters = section.querySelectorAll('[data-oddit-carousel-counter]');

    var total = slides.length;
    var totalPadded = pad(total);

    var autoplayEnabled = section.getAttribute('data-autoplay') === 'true' && total > 1;
    var autoplaySpeed = parseInt(section.getAttribute('data-autoplay-speed'), 10);
    if (isNaN(autoplaySpeed) || autoplaySpeed <= 0) autoplaySpeed = 5;
    var autoplayMs = autoplaySpeed * 1000;
    var autoplayTimer = null;
    var userInteracted = false;

    function getSlideWidth() {
      var first = slides[0];
      if (!first) return 0;
      return first.getBoundingClientRect().width;
    }

    function getActiveIndex() {
      var slideWidth = getSlideWidth();
      if (slideWidth <= 0) return 0;
      var idx = Math.round(track.scrollLeft / slideWidth);
      if (idx < 0) idx = 0;
      if (idx > total - 1) idx = total - 1;
      return idx;
    }

    function updateState() {
      var idx = getActiveIndex();
      var maxScroll = track.scrollWidth - track.clientWidth;
      var atStart = track.scrollLeft <= 1;
      var atEnd = track.scrollLeft >= maxScroll - 1;

      for (var i = 0; i < prevButtons.length; i++) {
        prevButtons[i].disabled = atStart;
      }
      for (var j = 0; j < nextButtons.length; j++) {
        nextButtons[j].disabled = atEnd;
      }

      var label = pad(idx + 1) + '/' + totalPadded;
      for (var k = 0; k < counters.length; k++) {
        counters[k].textContent = label;
      }
    }

    function scrollToIndex(idx) {
      var slideWidth = getSlideWidth();
      track.scrollTo({
        left: slideWidth * idx,
        behavior: 'smooth'
      });
    }

    function handlePrev() {
      userInteracted = true;
      stopAutoplay();
      var idx = getActiveIndex();
      scrollToIndex(Math.max(0, idx - 1));
    }

    function handleNext() {
      var idx = getActiveIndex();
      var nextIdx = idx + 1;
      if (nextIdx >= total) nextIdx = 0;
      scrollToIndex(nextIdx);
    }

    function autoplayAdvance() {
      if (document.hidden) return;
      var idx = getActiveIndex();
      var nextIdx = idx + 1;
      if (nextIdx >= total) nextIdx = 0;
      scrollToIndex(nextIdx);
    }

    function startAutoplay() {
      if (!autoplayEnabled || userInteracted) return;
      stopAutoplay();
      autoplayTimer = window.setInterval(autoplayAdvance, autoplayMs);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    for (var i = 0; i < prevButtons.length; i++) {
      prevButtons[i].addEventListener('click', handlePrev);
    }
    for (var j = 0; j < nextButtons.length; j++) {
      nextButtons[j].addEventListener('click', function () {
        userInteracted = true;
        stopAutoplay();
        handleNext();
      });
    }

    var scrollRafId = null;
    function onScroll() {
      if (scrollRafId) return;
      scrollRafId = requestAnimationFrame(function () {
        updateState();
        scrollRafId = null;
      });
    }
    track.addEventListener('scroll', onScroll, { passive: true });

    track.addEventListener('pointerdown', function () {
      userInteracted = true;
      stopAutoplay();
    });

    var resizeObserver = null;
    if (typeof ResizeObserver !== 'undefined') {
      resizeObserver = new ResizeObserver(function () {
        updateState();
      });
      resizeObserver.observe(track);
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stopAutoplay();
      } else if (autoplayEnabled && !userInteracted) {
        startAutoplay();
      }
    });

    updateState();
    startAutoplay();

    sectionState.set(section, {
      track: track,
      onScroll: onScroll,
      resizeObserver: resizeObserver,
      stopAutoplay: stopAutoplay
    });
  }

  function destroySection(section) {
    var state = sectionState.get(section);
    if (!state) return;
    state.stopAutoplay();
    state.track.removeEventListener('scroll', state.onScroll);
    if (state.resizeObserver) state.resizeObserver.disconnect();
    sectionState.delete(section);
  }

  function initAll() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();
